"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParams = exports.createUrl = exports.optionalModule = void 0;
// probably due to some collision with next server/client stuff
function optionalModule(callback) {
    try {
        return callback();
    }
    catch (_a) {
        // do nothing
    }
    return null;
}
exports.optionalModule = optionalModule;
// Convert an object into url params I.E: {"dog": "1", "cat": "2"} = "dog=1&cat=2"
function createUrl(currentUrl, appendedParams) {
    if (Object.keys(appendedParams).length <= 0) {
        return currentUrl;
    }
    let newParamString = '';
    const currentParams = getUrlParams(currentUrl);
    const newParams = Object.assign(Object.assign({}, currentParams), appendedParams);
    Object.keys(newParams)
        .forEach((key) => {
        let value = newParams[key];
        if (Array.isArray(value))
            value = value.join(',');
        // Skip 204 values
        if (value === '' || value === undefined || value === null)
            return;
        if (newParamString !== '')
            newParamString += '&';
        newParamString += `${key}=${encodeURIComponent(value)}`;
    });
    const baseUrl = currentUrl.split('?')[0];
    if (newParamString !== '') {
        newParamString = `?${newParamString}`;
    }
    return `${baseUrl}${newParamString}`;
}
exports.createUrl = createUrl;
function getUrlParams(url) {
    const params = new URLSearchParams(url.split('?')[1]);
    const obj = {};
    params.forEach((value, key) => {
        obj[key] = value;
    });
    return obj;
}
exports.getUrlParams = getUrlParams;
